var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffSoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 18.4767V13.5247C4.66797 12.8174 4.94892 12.1391 5.44902 11.6391C5.94911 11.139 6.62739 10.858 7.33464 10.858H11.2013C11.462 10.8579 11.717 10.7814 11.9346 10.638L19.9346 5.36334C20.1356 5.23096 20.3687 5.15547 20.6092 5.14485C20.8496 5.13424 21.0884 5.1889 21.3003 5.30305C21.5122 5.41719 21.6893 5.58656 21.8127 5.79319C21.9361 5.99981 22.0013 6.23599 22.0013 6.47667V25.5247C22.0013 25.7653 21.9361 26.0015 21.8127 26.2081C21.6893 26.4148 21.5122 26.5841 21.3003 26.6983C21.0884 26.8124 20.8496 26.8671 20.6092 26.8565C20.3687 26.8459 20.1356 26.7704 19.9346 26.638L11.9346 21.3633C11.717 21.2199 11.462 21.1434 11.2013 21.1433H7.33464C6.62739 21.1433 5.94911 20.8624 5.44902 20.3623C4.94892 19.8622 4.66797 19.1839 4.66797 18.4767Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3359 20V12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffSoundIcon);
export default __webpack_public_path__ + "static/media/off-sound-icon.d69b1c0d8984693380e2f6c051a04d88.svg";
export { ForwardRef as ReactComponent };